import './xmlViewer.css';
import { toXML } from 'jstoxml';

const XmlViewer = ({ data }) => {
    const config = {
        indent: '    '
    };

    const xmlData = toXML(data, config);
    return (
        <div className="xmlContainer">
            <pre>
                {xmlData}
            </pre>
        </div>
    )
}

export default XmlViewer